import { render, staticRenderFns } from "./voucher-sale-amount.vue?vue&type=template&id=af1786d0&"
import script from "./voucher-sale-amount.vue?vue&type=script&lang=js&"
export * from "./voucher-sale-amount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports